import React from "react";
import { toast } from "react-toastify";
import FormPageLayout from "../FormPageLayout";
import FormLayout from "../FormLayout";
import InviteCustomerForm from "./InviteCustomerForm";
import { sendCustomerInvite } from "../../../actions/onboarding";
import "./InviteForm.css";

export default function InviteForm() {
  const layout = {
    labelCol: {
      span: 24,
    },
    wrapperCol: {
      span: 24,
    },
    layout: "vertical",
  };

  /**
   * Make an api call to send the invitation email to the cusotmer
   * @param {object} formData
   * @returns {boolean} true if successful
   */
  const onFinish = async (formData) => {
    const payload = {
      company_name: formData.company_name,
      customer_name: formData.customer_name,
      customer_email: formData.customer_email,
      customer_type: formData.customer_type,
      sales_email: formData.sales_email,
      csm_email: formData.csm_email,
      data_ops_email: formData.data_ops_email,
      ...(formData.customer_id ? { customer_id: formData.customer_id } : {}),
    };
    const resp = await sendCustomerInvite(payload);
    if (resp.success) {
      toast.success("User invited successfully");
      return true;
    }
    toast.error(resp.message ?? "Something went wrong");
    return false;
  };

  return (
    <FormPageLayout className="InviteFormPageLayout">
      <FormLayout title="Customer Invite" className="InviteForm">
        <InviteCustomerForm onFinish={onFinish} layout={layout} />
      </FormLayout>
    </FormPageLayout>
  );
}
